import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetDescriptionParams } from '../types/actionParams';

export class SetColumnDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setColumnDescription', {
      id: id,
      description: description
    });
  }
}
